// -----------------------------------------------------------------------------
// Core
// -----------------------------------------------------------------------------

import alternativeValues from '../alt1';

// -----------------------------------------------------------------------------
// Keys
// -----------------------------------------------------------------------------

const keys = {
	// row 0
	ё: [''],
	Ё: ['₴'],
	'₴': ['Ё'],

	// row 1
	ъ: ['ї'],
	ї: ['ъ'],
	Ъ: ['Ї'],
	Ї: ['Ъ'],

	// row 2
	ы: ['і'],
	і: ['ы'],
	э: ['є'],
	є: ['э'],
	Ы: ['І'],
	І: ['Ы'],
	Э: ['Є'],
	Є: ['Э']
};

// -----------------------------------------------------------------------------
// Export
// -----------------------------------------------------------------------------

export default alternativeValues(keys);
